import { useEffect } from 'react';

import { usePrevious } from '@mantine/hooks';
import { IconDelete } from 'ui-icons';

import { ActionIcon } from '../../../../../Buttons/ActionIcon/ActionIcon';
import { TextInput, TextInputProps } from '../../../../../Inputs/TextInput';
import { Group } from '../../../../../Layout/Group';
import { useAdditionalFieldsContext } from '../AdditionalFields.context';

type FieldLabelProps = {
  index: number;
  onRemove: (index: number) => void;
  isInputDisabled?: boolean;
  showRemoveButton?: boolean;
} & Pick<
  TextInputProps,
  'value' | 'defaultValue' | 'onChange' | 'required' | 'placeholder' | 'readOnly'
>;

const FieldLabel = ({
  index,
  onRemove,
  isInputDisabled,
  showRemoveButton = true,
  ...rest
}: FieldLabelProps) => {
  const previousValue = usePrevious(rest.value);
  const { isDisabled } = useAdditionalFieldsContext();

  useEffect(() => {
    if (rest.value !== previousValue) {
      if (rest.value && typeof rest.value == 'string') {
        // @ts-expect-error -- Onchange is passed through a local override of the form get input props
        rest.onChange?.(rest.value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rest.value]);

  return (
    <Group grow gap="sm">
      <TextInput placeholder="Enter Label" readOnly={isDisabled || isInputDisabled} {...rest} />
      {!isDisabled && showRemoveButton && (
        <ActionIcon
          variant="subtle"
          color="cerise"
          style={{ flexGrow: 0 }}
          onClick={() => onRemove(index)}
        >
          <IconDelete />
        </ActionIcon>
      )}
    </Group>
  );
};

export { FieldLabel };
